import React from "react";
import useSubscription from "../hooks/useSubscription";
import { useAuth } from "../contexts/AuthContext";
import { isDemoMode } from "../services/demoService";
import PaymentRequired from "./PaymentRequired";

// Status que EXIGEM pagamento antes de liberar o app.
const BLOCKING_STATUSES = ["pending_payment", "trial_expired"];

/**
 * Portão de pagamento obrigatório. Renderiza um overlay bloqueante quando a
 * assinatura do usuário está pendente de pagamento. Some automaticamente
 * assim que o pagamento é confirmado (status 'active').
 */
export default function PaywallGate() {
  const { user } = useAuth();
  const { status, isGod } = useSubscription();

  const isLegacy = !user?.billingClass;

  const exempt =
    isGod ||
    user?.cargo === "god" ||
    isDemoMode() ||
    user?.isDemo ||
    !!user?.invitedAt ||
    isLegacy; // usuários legados (admin/user sem billingClass) → acesso vitalício

  if (exempt) return null;
  if (!BLOCKING_STATUSES.includes(status)) return null;

  return <PaymentRequired status={status} />;
}
